export default __webpack_public_path__ + "static/media/Ki.04e38acf.eot";